export default __webpack_public_path__ + "../staticImages/strand_weiss-260.png";